console.log('including online-global...');
/////////////////////////////////////////////
///////////// Execute stuff /////////////////
/////////////////////////////////////////////

// import 'jquery-ui/dist/jquery-ui.js';
// import 'jquery-ui-touch-punch/jquery.ui.touch-punch.js';
// require ('jquery-ui/dist/jquery-ui.js');
// require ('jquery-ui-touch-punch/jquery.ui.touch-punch.js');


// This will start the periodic check/send of async logs
window.intervalLoggerId = setInterval(function() { asyncLogSendAll(); }, 60000);


/////////////////////////////////////////////
//////////////// FUNCTIONS //////////////////
/////////////////////////////////////////////

window.asyncLog = function(message,severity,extra_data,put_stacktrace){
    if(!severity) severity = 'warning';

    var log_object = {
        severity  :severity,
        timestamp :(new Date).toISOString(),
        message   :message,
        trace     : (!put_stacktrace) ? false : stackTrace(),
        user_agent:navigator.userAgent,
        extra_data:extra_data,
    }
    asyncLogStore(log_object);
}

///////////////////////////////////
window.asyncLogStore = function(log_object){
    // console.log(log_object)
    var previous_logs = asyncLogGetAll();
    if(previous_logs.length > 500) previous_logs.shift(); // prevents stating too much in the storage
    previous_logs.push(log_object);
    localStorage.setItem('asyncLogger', JSON.stringify(previous_logs));
}
window.asyncLogGetAll = function(){
    asyncLogInit()
    return JSON.parse(localStorage.getItem('asyncLogger'));
}
window.asyncLogInit = function(){
    if(
        typeof localStorage.asyncLogger === "undefined"
        || ! isJsonString(localStorage.getItem('asyncLogger'))
        || ! JSON.parse(localStorage.getItem('asyncLogger')) instanceof Array
    ) asyncLogClean();
}
window.asyncLogClean = function(){
    localStorage.setItem('asyncLogger', JSON.stringify([]));
}


window.asyncLogSendAll = function(){
    var data = asyncLogGetAll();
    if(data.length < 1) return;
    // console.log("Sending asynclog")

    $.ajax({
        url: 'asynclog',
        data: {
            data: data,
            _token: csrf_token
        },
        success: function(data){
            // console.log('asyncLogSendAll success:',data)
            if(data === true) asyncLogClean();
            // else asyncLog('sent asyncLog but server error','warning')
        },
        error: function(data){
            // console.log('asyncLogSendAll error:',data)
            // asyncLog('Unable to send asyncLog','error')
        },
        timeout: 20000, // 20s timeout, must be smaller than the periodic interval of intervalLoggerId
        type: 'POST'
    });
}

window.stackTrace = function() {
    // return console.trace()
    var err = new Error();
    return err.stack;
}

window.isJsonString = function(str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}